import React from 'react';
import ReactDOMClient, { createRoot } from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter, Routes } from 'react-router-dom';
import history from 'history/browser';
import { HelmetProvider } from 'react-helmet-async';

import { AppContext, type AppContextValue } from 'src/context/AppContext';
import { Routes as AppRoutes } from 'src/routes';

type AppServerContext = Omit<AppContextValue, 'setPersonalStats'>;
declare global {
  interface Window {
    __ctx?: AppServerContext | null;
  }
}

const initialPersonalStats = window.__ctx?.personalStats ?? null;

const container = document.getElementById('root');

const Wrap = (
  <HelmetProvider>
    <HistoryRouter
      history={history as any}
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <AppContext initialPersonalStats={initialPersonalStats}>
        <Routes>{AppRoutes}</Routes>
      </AppContext>
    </HistoryRouter>
  </HelmetProvider>
);

if (container) {
  if (process.env.WEBSITE_SSR) {
    ReactDOMClient.hydrateRoot(container, Wrap);
  } else {
    createRoot(container).render(Wrap);
  }
} else {
  throw new Error('No #root element in DOM');
}
